import {User} from "./adminstate";

export enum AuthScope {
    "ADMIN" = "wf:admin",
    "SUPERADMIN" = "wf:superadmin",
    "PFD_CREATE" = "wf:pdf_create",
}

export interface UserInfo extends User {
    scopes: AuthScope[];
    picture?: string;
    storeUrl?: string;
    profileUrl?: string;
}

export function getUserFullName(user?: UserInfo): string | undefined{
    if (user) {
        if (user.firstname || user.lastname){
            return `${user.firstname || ""} ${user.lastname || ""}`.trim();
        } else {
            return user.email.trim();
        }
    }
}

export interface LoginInput {
    username: string;
    password: string;
    from?: string | null;
}

export interface UserUpdateProfileData {
    name?: string;
}

export interface BEUserStats {
    sessions: {
        closed: number;
    };
    credits: {
        available: number;
        consumed: number;
        infinite: boolean;
    };
}